import type { EventHookOn } from '@vueuse/core';

export type UseActionHook = {
  onActionHook: EventHookOn<{ trophyIds: string[] }>;
  complete: (b: boolean) => void;
};

export const useActionHook = (
  name: string,
  onlyOnce: boolean = false,
  minDelayCall: number = -1,
  requiredActions: string[] = [],
  waitBeforePlay: number = -1,
  forcedAutoRegistration: boolean = false
): UseActionHook => {
  const { onPlay, complete, registerAction } = useAbstractAction(
    name,
    onlyOnce,
    minDelayCall,
    requiredActions,
    waitBeforePlay,
    forcedAutoRegistration
  );

  const actionHook = createEventHook();

  const actions = useActionsStore();

  const unsubscribeActionsInit = actions.onActionsInit((e) => {
    registerAction();
  });

  onPlay(() => {
    actionHook.trigger();
  });

  onUnmounted(() => {
    useActionsStore().releaseAction(name);
    unsubscribeActionsInit.off();
  });

  return {
    onActionHook: actionHook.on,
    complete,
  };
};
